// extracted by mini-css-extract-plugin
export default {"button":"style_button__WaObv","flexStart":"style_flexStart__zeJkG","icon":"style_icon__dj43K","legend":"style_legend__FKmy1"};